import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IconLocation, ImageLocation } from '../../../../utils/URLUtils';
import styles from './FriendFooter.module.scss';
import { SelectCountry } from './SelectCountry/SelectCountry';

interface FriendFooterProps {
    selectedTab: string;
    length: number;
}

export const FriendFooter = ({ selectedTab, length }: FriendFooterProps) => {
    const { t } = useTranslation();
    // const { userInfo } = useUser();
    //const { open } = useIFrameModal();
    const navigate = useNavigate();


    const handleAddFriend = () => {
        navigate('/add-friend');
        //  open(GetRazorSiteUrl('profile/add-friend', userInfo?.Token), t('Add a Friend'));
    };

    return (
        <div className={styles.friendFooter}>
            {selectedTab === 'friends' &&
                <button className={styles.addFriend} onClick={handleAddFriend}>
                    <img src={IconLocation('user-plus', true)} alt={t('Plus')} />
                    {t('Add Friends')}
                </button>}
            {
                selectedTab === 'peopleNearBy' &&
                <div className={styles.locationContainer}>
                    {length !== 0 ?
                        <div className={styles.text}>
                            {
                                t('You see the most active users during the past 7 days. Practice more to be on top of the list!')
                            }
                        </div>

                        :
                        <div className={styles.text}>
                            <img src={ImageLocation('Lexi/addfriend.png')}
                                alt={t('Sad Face')} />
                            <p>{t('Learning in WordUp is')}</p>
                            <p>{t('more fun with friends.')}</p>
                        </div>

                    }

                    <SelectCountry />
                </div>
            }
        </div>
    );
};